import React, { useEffect, useState } from 'react';
import {
  Card, CardContent, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Box, Button,
  TablePagination
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ApiService from '../../_services/ApiService';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Takedown from './takedownModal';
import dayjs from 'dayjs';
import ReusableTab from '../../_helpers/reusablefunctions/ReusableTab';
import AudioPlayer from '../../components/reusableComponents/customAudioPlayer';
import { GetApp } from '@mui/icons-material';
import { downloadImage } from '../../_helpers/reusablefunctions/downloadImage';
import { UpdateAlbumApprover } from '../../_services/songApprover/updateAlbumApprover';

const styleImage = { width: '115px', height: '115px', objectFit: 'cover' };

const AlbumComparison = () => {
  const { songId, albumId } = useParams();
  const location = useLocation()?.state;
  const history = useHistory();
  const songList = location?.albumSongLibrary || [];
  const [openTakeDown, setOpenTakeDown] = useState(false);
  const [takedown_date, setTakedown_date] = useState('');
  const [tabValue, setTabValue] = useState(location?.album_history || 'album');
  const [albumData, setAlbumData] = useState([]);
  const [songData, setSongData] = useState({});
  const [noData, setNoData] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const songAlbumId = location?.album_history === "song_history" ? songId : albumId;

  const fetchAlbumHistory = () => {
    setSongData([])
    ApiService.get('album_history', {}, songAlbumId + '/')
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setAlbumData(res?.data?.updates || []);
          setNoData('');
        } else {
          setNoData(res?.data?.message);
        }
      })
      .catch(console.error);
  };

  const fetchSongHistory = (songId) => {
    setAlbumData([])
    ApiService.get('song_history', {}, songId + '/')
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setSongData((prev) => ({
            ...prev,
            [songId]: res?.data?.updates || [],
          }));
          setNoData('');
        } else {
          setNoData(res?.data?.message);
        }
      })
      .catch(console.error);
  };

  const fetchTakedownHistory = () => {
    ApiService.get("takedown_history", {}, albumId + '/removed-platforms/')
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setAlbumData(res?.data?.updates || []);
        } else {
          setNoData(res?.data?.message)
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (tabValue === "takedown") {
      fetchTakedownHistory();
    } else if (tabValue === 'album') {
      fetchAlbumHistory();
    } else {
      fetchSongHistory(tabValue);
    }
  }, [tabValue]);

  useEffect(() => {
    if (songList.length > 0) {
      setTabValue('album');
    }
  }, [songList]);

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const historyBack = () => {
    if (location?.album_history === "song_history") {
      history.push(`/submitsong/${songId}/${albumId}`);
    } else {
      history.push(`/albumdetail/${albumId}`);
    }
  };

  const takedownHandler = (newValue) => {
    setTakedown_date(newValue.format('YYYY-MM-DD'));
  };

  const submitAlbumDetail = () => {
    const postData = {
      song_status: "Takedown",
      takedown_date: takedown_date
    };

    ApiService.put('updateUpc', postData, {}, albumId).then((response) => {
      if (response.status === 200) {
        setOpenTakeDown(false);
        history.push(`/albumdetail/${albumId}`);
      }
    })
      .catch(console.error);
  };

  const groupByDate = (updates) => {
    return updates.reduce((acc, item) => {
      const dateKey = dayjs(item.updated_at || item.removed_on).format('YYYY-MM-DD');
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(item);
      return acc;
    }, {});
  };

  const activeData = tabValue === 'album' ? albumData : songData[tabValue] || albumData;
  const groupedData = groupByDate(activeData);

  const accountTabs = [
    {
      tabTitle: "Album- " + location?.albumData?.album_name || 'Album',
      tabActiveId: 'album',
    },
    ...songList.map((item) => ({
      tabTitle: "Song- " + item.song.song_name,
      tabActiveId: item.song.song_id.toString(),
    })),
  ];

  const panels = accountTabs.map((item) => ({
    value: item.tabActiveId,
  }));

  return (
    <Box className="mx-4 mt-4 mb-5 pb-5">
      <Box className="d-flex justify-content-between align-item-center">
        <Button className="icononly-btn d-flex mb-3" onClick={historyBack}>
          <ArrowBackIcon />
          <p className="cardheading ms-2">
            {location?.albumData?.album_name || location?.albumData?.song_name || "--"}
          </p>
        </Button>
        {(location?.albumData?.song_status === "Takedown Requested") && (
          <Button variant="text" onClick={() => setOpenTakeDown(true)}>
            Takedown
          </Button>
        )}
      </Box>

      <ReusableTab
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        accountTabs={accountTabs}
        panels={panels}
      />

      <Card>
        <CardContent>
          <TableContainer component={Paper} sx={{ maxHeight: 500, overflowY: 'auto', boxShadow: 'none' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', width: '25%' }}></TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '35%' }}>
                    {location?.album_history !== "takedown" ? "Old Value" : "Takedown Date"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold', width: '40%' }}>
                    {location?.album_history === "takedown" ? "Platform Name" : "New Value"}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activeData?.length > 0 ? (
                  Object.entries(groupedData).map(([date, updates], groupIndex) => (
                    <React.Fragment key={groupIndex}>
                      <TableRow>
                        <TableCell colSpan={4} sx={{ fontWeight: 'bold', background: '#f3f3f3' }}>
                          {dayjs(date).format('DD MMM YYYY')}
                        </TableCell>
                      </TableRow>
                      {updates.map((data, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {data?.field_name || 'Platform'}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {location?.album_history !== "takedown" ? (
                              data?.field_name === "cover_image" ? (
                                <Box className='position-relative'>
                                  <img
                                    src={process.env.REACT_APP_SONGAPIURL_MEDIA + data?.old_value}
                                    style={styleImage}
                                    alt="Old Cover"
                                  />
                                </Box>
                              ) : data?.field_name === "song_file" ? (
                                <AudioPlayer
                                  className={'w-75'}
                                  page='page'
                                  type='releasealbumplayer'
                                  audioSrc={process.env.REACT_APP_SONGAPIURL_MEDIA  + data.old_value}
                                />
                              ) : (
                                data?.old_value === 'True' ? 'Yes' : data?.old_value === 'False' ? 'No' : data?.old_value || '-'
                              )
                            ) : (
                              data?.takedown_date || ''
                            )}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {data?.field_name === "cover_image" ? (
                              <Box className='position-relative'>
                                <img
                                  src={process.env.REACT_APP_SONGAPIURL_MEDIA  + data?.new_value}
                                  style={styleImage}
                                  alt="New Cover"
                                />
                                <GetApp
                                  sx={{
                                    width: "18px",
                                    position: 'absolute',
                                    bottom: '10px',
                                    cursor: 'pointer'
                                  }}
                                  className='bg-white'
                                  onClick={() =>
                                    downloadImage(
                                      data?.field_name,
                                      data?.new_value
                                        ? process.env.REACT_APP_SONGAPIURL_MEDIA  + data?.new_value
                                        : ''
                                    )
                                  }
                                />
                              </Box>
                            ) : data?.field_name === "song_file" ? (
                              <AudioPlayer
                                className={'w-75'}
                                page='page'
                                type='releasealbumplayer'
                                audioSrc={process.env.REACT_APP_SONGAPIURL_MEDIA  + data.new_value}
                              />
                            ) : (
                              data?.new_value === 'True' ? 'Yes' : data?.new_value === 'False' ? 'No' : data?.new_value || data?.platform || '-'
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      <Typography>{noData || "No history available"}</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={Object.keys(groupByDate(activeData)).length}
            page={page}
            // onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            // onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[]}
            labelRowsPerPage=""
          />
        </CardContent>
      </Card>

      <Takedown
        open={openTakeDown}
        takedown_date={takedown_date}
        takedownHandler={takedownHandler}
        handleClose={() => setOpenTakeDown(false)}
        submitRequest={submitAlbumDetail}
      />
    </Box>
  );
};

export default AlbumComparison;
